























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { ContractModel } from '@/app/shared/models';
@Component
export default class FormContractComponent extends Vue {
  @Prop(Object) readonly data!: ContractModel;
  private menu1 = false;

  private get updateContract() {
    return this.data.DueDateUpdateDate
      ? this.refs
          .moment()
          .diff(this.refs.moment(this.data.DueDateUpdateDate), 'month') > 6
      : true;
  }
  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }
  private get listNumberOfInstallments() {
    return Array.from({ length: 12 }, (_, i) => i + 1);
  }
  private get listDueDate() {
    return Array.from({ length: 31 }, (_, i) => i + 1);
  }
}
